import { lazy } from "react";
import { NavigationRoute } from ".";

const EditProfile = lazy(() => import("@components/pages/shared/profile/EditProfile"));
const ChangePassword = lazy(() => import("@components/pages/shared/profile/ChangePassword"));

const CourseJourney = lazy(() => import ('@components/pages/shared/courseJourney/CourseJourney'));
const NotificationCenter = lazy(() => import('@components/pages/shared/notifications/NotificationCenter'));
const MyBugsPage = lazy(() => import('@components/pages/shared/my-bugs/MyBugsPage'));
// AiTutor + AiTutorRoute imports removed per Chronicle boundary (2026-04-15).
// Component code preserved at components/pages/shared/ai/ as Chronicle incubator.

const appRoutes: NavigationRoute[] = [
  // PROFILE
  {
    path: "/course/:course_id",
    label: "Course",
    component: <div>/course/:course_id</div>,
  },
  {
    path: ":role/profile/edit",
    label: "Edit Profile",
    component: <EditProfile />
  },
  {
    path: ":role/profile/change-password",
    label: "Change Password",
    component: <ChangePassword />
  },
  {
    path: ":role/course/:course_id/journey/:topic_id?/:lesson_id?/:activity_id?",
    label: "Course Journey",
    component: <CourseJourney />
  },
  {
    path: "/notifications",
    label: "Notifications",
    component: <NotificationCenter />,
  },
  {
    path: "/my-bugs",
    label: "My Bug Reports",
    component: <MyBugsPage />,
  },
  // /ai/tutor and /ai/tutor/:course_id routes removed per Chronicle boundary
  // (2026-04-15). AI Tutor is a Chronicle-exclusive feature; when Chronicle
  // is enabled, it will mount its own routes under the Chronicle section.
];

export default appRoutes;
